import { GetProfileWeeklySummaryQuery } from "types/graphql-schema";

import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import SummaryLineSources from "./summary-line-sources";

type SummaryLineData = NonNullable<
  GetProfileWeeklySummaryQuery["profileWeeklySummary"]
>["insights"][number];

// One sparkle-bulleted summary line. Insights keep only a source count; activity
// shows slimmed source chips (see SummaryLineSources).
const SummaryLine = ({
  line,
  variant,
}: {
  line: SummaryLineData;
  variant: "insight" | "activity";
}) => (
  <div className="flex gap-2.5">
    <TopicflowIcon
      type="ai"
      className="mt-0.5 h-4 w-4 shrink-0 text-gray-400"
    />
    <div className="flex min-w-0 flex-col gap-1.5">
      <div className="text-sm leading-snug text-gray-800">{line.text}</div>
      <SummaryLineSources sources={line.sources} variant={variant} />
    </div>
  </div>
);

export default SummaryLine;
